import {
    apiRequest,
    angkaKreditCreate,
} from "../../../../../services/adapters/kepegawaian/pengajuanAngkaKreditService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", angkaKreditCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository